<template>
  <div v-show="theme !== 'athena' || onload">
    <template v-if="theme !== 'athena'">
      <div style="margin-top: 12px" v-for="item in code_display_show" :key="item.ID" class="manner" :class="theme">
        <div class="left">
          <h3 class="secondary_title">{{ $t('codedispy.extra') }}</h3>
          <el-tooltip popper-class="codedisplay-tip" effect="light" :content="item.name" placement="top" :visible-arrow="false">
          <p class="page_text_font">{{ item.name }}</p>
          </el-tooltip>
        </div>
        <div class="right">
          <h4 class="secondary_title" :class="theme == 'vogue' ? 'text-uppercase' : ''" style="color: #fff7d7">
            {{ onoff ? $t('codedisplay.copied') : $t('codedisplay.copycode') }}
          </h4>
          <!-- <input style="display:none" :id="item.ID" type="text" :value="item.code" /> -->
          <p style="cursor: pointer" @click="copy(item.code)"><span>{{ item.code }}</span></p>
        </div>
        <!-- <img
          width="100%"
          alt="codedisplay"
          style="position: relative"
          @load="onload = true"
          :src="discountExhibitionImg"
        />        -->
        <svg style="width:100%" width="400" height="78" viewBox="0 0 400 78" fill="none">
          <rect width="400" height="78" rx="6" fill="#FF0000"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M393 6C393 4.89543 392.105 4 391 4H10C8.89543 4 8 4.89543 8 6V7.46521C8 8.41641 8.69937 9.20063 9.52047 9.68082C11.0037 10.5482 12 12.1578 12 14C12 16.0328 10.7869 17.7822 9.04519 18.5639C8.46127 18.826 8 19.36 8 20V20C8 20.64 8.46127 21.174 9.04519 21.4361C10.7869 22.2178 12 23.9672 12 26C12 28.0328 10.7869 29.7822 9.04519 30.5639C8.46127 30.826 8 31.36 8 32V32C8 32.64 8.46127 33.174 9.04519 33.4361C10.7869 34.2178 12 35.9672 12 38C12 40.0328 10.7869 41.7822 9.04519 42.5639C8.46127 42.826 8 43.36 8 44V44C8 44.64 8.46127 45.174 9.04519 45.4361C10.7869 46.2178 12 47.9672 12 50C12 52.0328 10.7869 53.7822 9.04519 54.5639C8.46127 54.826 8 55.36 8 56V56C8 56.64 8.46127 57.174 9.04519 57.4361C10.7869 58.2178 12 59.9672 12 62C12 63.8422 11.0037 65.4518 9.52047 66.3192C8.69937 66.7994 8 67.5836 8 68.5348V71C8 72.1046 8.89542 73 9.99999 73H391C392.105 73 393 72.1046 393 71V6Z" fill="url(#paint0_linear_937_3342)"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M394 0H247V9.82104C260.192 12.9742 270 24.8417 270 39C270 53.1583 260.192 65.0258 247 68.179V78H394C397.314 78 400 75.3137 400 72V6C400 2.68629 397.314 0 394 0Z" fill="url(#paint1_linear_937_3342)"/>
          <rect id='mannerImage' x="277" y="34" width="111" height="32" rx="16" fill="url(#paint2_linear_937_3342)"/>
          <rect x="365.75" y="43.75" width="7.5" height="8.5" rx="1.25" stroke="#FF8328" stroke-width="1.5"/>
          <rect x="369.75" y="47.75" width="7.5" height="8.5" rx="1.25" stroke="#FF8328" stroke-width="1.5"/>
          <defs>
            <linearGradient id="paint0_linear_937_3342" x1="8" y1="38" x2="393" y2="38" gradientUnits="userSpaceOnUse">
              <stop stop-color="#FFF7E8"/>
              <stop offset="1" stop-color="#FDE8C8"/>
            </linearGradient>
            <linearGradient id="paint1_linear_937_3342" x1="323.5" y1="0" x2="323.5" y2="78" gradientUnits="userSpaceOnUse">
              <stop stop-color="#FF871D"/>
              <stop offset="1" stop-color="#FF6D1D"/>
            </linearGradient>
            <linearGradient id="paint2_linear_937_3342" x1="277" y1="50" x2="388" y2="50" gradientUnits="userSpaceOnUse">
              <stop stop-color="#FAE2A3"/>
              <stop offset="0.541667" stop-color="#F8E9D2"/>
              <stop offset="1" stop-color="#F5E5AD"/>
            </linearGradient>
            <linearGradient id="paint2_linear_937_3344" x1="277" y1="50" x2="388" y2="50" gradientUnits="userSpaceOnUse">
              <stop stop-color="#FFF2CE"/>
              <stop offset="0.541667" stop-color="#FFFAF3"/>
              <stop offset="1" stop-color="#F5E5AD"/>
              <stop offset="1" stop-color="#FFF2CE"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
    </template>
    <template v-else>
      <div style="margin-top: 12px" :key="item.ID" :class="theme" v-for="(item, index) in code_display_show_list">
        <div class="new_codedisplay">
          <div class="new_codedisplay_main" :class="'new_codedisplay_main_' + index">
            <el-tooltip popper-class="codedisplay-tip" effect="light" :content="item.name" placement="top" :visible-arrow="false">
            <p class="page_text_font text-overflow-1">{{ item.name }}</p>
            </el-tooltip>
            <div class="text-overflow-1" @click="new_copy(item.code, index)" v-show="!item.copy_on_off">
              <span class="text-overflow-1"> {{ $t('codedisplay.copycode') }} : {{ item.code }}</span>
              <span class="iconfont icon-cm-fuzhi"></span>
            </div>
            <div v-show="item.copy_on_off">
              <span class="iconfont icon-cm-duigou1"></span> {{ $t('codedisplay.copied') }}
            </div>
          </div>
          <img
            class="new_codedisplay_left"
            :src="require(`@/images/new_codedisplay_${index}_left.png`).default"
            alt=""
            @load="onload = true"
          />
          <img
            class="new_codedisplay_right"
            :src="require(`@/images/new_codedisplay_${index}_right.png`).default"
            alt=""
            @load="onload = true"
          />
        </div>
      </div>
    </template>
    <el-dialog custom-class="codeDialog" :visible="visible" append-to-body center>
      <div class="tip">
        <h2 style="margin: 0; color: #ff8328" class="secondary_title">{{ $t('comment.success') }}</h2>
        <p class="page_text_font" style="color: #ff8328">{{ $t('codedisplay.tip') }}</p>
      </div>
      <svg style="width:100%" viewBox="0 0 457 105">
        <defs>
          <linearGradient id="text-area" x1="0" y1="0" x2="457" y2="105" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff6e7" stop-opacity="1" />
            <stop offset="1" stop-color="#fce2bb" stop-opacity="1" />
          </linearGradient>
          <linearGradient id="line-1" x1="-19.82" y1="55.29" x2="137.59" y2="55.29" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fef3e0" stop-opacity="0.05" />
            <stop offset="0.5" stop-color="#fef2df" stop-opacity="0.2" />
            <stop offset="1" stop-color="#fef2de" stop-opacity="0.05" />
          </linearGradient>
          <linearGradient id="card-3" x1="55.83" y1="75.84" x2="55.83" y2="27.57"
            gradientTransform="translate(23.73 -20.7) rotate(22.33)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#ffd992" />
            <stop offset="1" stop-color="#ffe2be" />
          </linearGradient>
          <linearGradient id="card-1" x1="58.89" y1="78.97" x2="58.89" y2="33.99" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#ffd992" />
            <stop offset="1" stop-color="#ffe3c5" />
          </linearGradient>
          <filter id="card-shadow">
            <feGaussianBlur result="blurOut" in="offOut" stdDeviation="3" />
          </filter>
        </defs>
        <g>
          <rect width="457" height="105" rx="10" fill="#ff0000" />
          <rect width="441" height="89" rx="6" fill="url(#text-area)" transform="translate(8 8)" />
        </g>
        <g>
          <g>
            <rect width="118" height="105" rx="10" fill='#ff681e' />
            <rect fill="url(#line-1)" y="50.91" width="117.77" height="8.75" />
            <polygon fill="url(#line-1)" points="117.77 16.24 0 84.23 0 94.34 117.77 26.34 117.77 16.24" />
            <polygon fill="url(#line-1)" points="85.75 0 25.13 105 35.24 105 95.86 0 85.75 0" />
            <rect fill="url(#line-1)" x="54.51" width="8.75" height="105" />
            <polygon fill="url(#line-1)" points="21.91 0 82.53 105 92.64 105 32.02 0 21.91 0" />
            <polygon fill="url(#line-1)" points="0 16.24 0 26.34 117.77 94.34 117.77 84.23 0 16.24" />
          </g>
          <g>
            <rect x="28.61" y="30.1" width="54.25" height="36.49" rx="10" transform="translate(-12.77 20.94) rotate(-19.14)"
              fill="#c1431b" filter="url(#card-shadow)" opacity="0.5" mix-blend-mode="multiply" />
            <rect x="28.61" y="30.1" width="54.25" height="36.49" rx="10" transform="translate(-12.77 20.94) rotate(-19.14)"
              fill="url(#card-3)" />
          </g>
          <g>
            <rect x="33.6" y="31.56" width="54.25" height="36.49" rx="10" transform="translate(-6.24 8.77) rotate(-7.86)"
              fill="#c1431b" filter="url(#card-shadow)" opacity="0.5" mix-blend-mode="multiply" />
            <rect x="33.6" y="31.56" width="54.25" height="36.49" rx="10" transform="translate(-6.24 8.77) rotate(-7.86)"
              fill="url(#card-1)" />
          </g>
          <g>
            <path fill="#c1431b" filter="url(#card-shadow)" opacity="0.9" mix-blend-mode="multiply"
              d="M87.87,56.5A4.51,4.51,0,0,1,92.38,52V44a10,10,0,0,0-10-10h-47a10,10,0,0,0-10,10v8a4.52,4.52,0,0,1,0,9V69a10,10,0,0,0,10,10h47a10,10,0,0,0,10-10V61A4.51,4.51,0,0,1,87.87,56.5Z" />
            <path fill="url(#card-1)"
              d="M87.87,56.5A4.51,4.51,0,0,1,92.38,52V44a10,10,0,0,0-10-10h-47a10,10,0,0,0-10,10v8a4.52,4.52,0,0,1,0,9V69a10,10,0,0,0,10,10h47a10,10,0,0,0,10-10V61A4.51,4.51,0,0,1,87.87,56.5Z" />
          </g>
          <path fill="#ff8328"
            d="M53.27,65.15a5,5,0,0,1-1.39-3.92v-.77H57V61a2.49,2.49,0,0,0,.48,1.76,1.73,1.73,0,0,0,1.27.48A1.56,1.56,0,0,0,60,62.7a2.19,2.19,0,0,0-.17-2.83,5.52,5.52,0,0,0-1.53-1c-.62-.28-1.29-.55-2-.82a9,9,0,0,1-2-1.08,5.37,5.37,0,0,1-1.53-1.74,5.65,5.65,0,0,1-.61-2.81q0-5.31,5.19-6.15V44.64H60v1.65A6.13,6.13,0,0,1,64.07,48a6.4,6.4,0,0,1,1.28,4.35H60.42v-.42a3,3,0,0,0-.37-1.49,1.23,1.23,0,0,0-1.14-.64,1.44,1.44,0,0,0-1.24.55,2,2,0,0,0-.4,1.21,2,2,0,0,0,.64,1.56,5.88,5.88,0,0,0,1.6,1c.64.27,1.33.53,2.07.79A8.44,8.44,0,0,1,63.65,56a5.66,5.66,0,0,1,1.6,1.79,5.84,5.84,0,0,1,.64,2.95A5.58,5.58,0,0,1,64.39,65,7.63,7.63,0,0,1,60,66.67v2.55h-2.6V66.67A7.2,7.2,0,0,1,53.27,65.15Z" />
        </g>
      </svg>
    </el-dialog>
  </div>
</template>

<script>
import discountExhibitionImg from '@/images/codedisplay1.png'
import discountsuccess from '@/images/success1.png'
export default {
  props: ['code_display_show', 'theme'],
  data() {
    return {
      discountExhibitionImg,
      discountsuccess,
      onoff: false,
      onload: false,
      visible: false,
      code_display_show_list: [],
    }
  },
  methods: {
    aav(e){
      this.onload= true;
      console.log(e,'eee',22);
    },
    copy(e) {
      this.onoff = true
      this.visible = true
      // this.$("#codedisplaytip").modal("show");
      let oInput = document.createElement('input')
      oInput.value = e
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      oInput.remove()
      setTimeout(() => {
        // this.$("#codedisplaytip").modal("hide");
        this.onoff = false
        this.visible = false
      }, 2000)
    },
    new_copy(e, index) {
      this.code_display_show_list[index]['copy_on_off'] = true
      this.copyToClip(e)
      setTimeout(() => {
        this.code_display_show_list[index]['copy_on_off'] = false
      }, 2000)
    },
    handleScroll() {
      document.activeElement.blur();
    }
  },
  mounted() {
    if (this.code_display_show && this.code_display_show.length) {
      this.code_display_show_list = this.code_display_show.map((item) => {
        return { ...item, copy_on_off: false }
      })
    }
    document.addEventListener('scroll', this.handleScroll)
  },
}
</script>

<style lang='scss'>
.codeDialog {
  &.el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
    width: 500px;
    border-radius: 15px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      flex: 1;
      overflow: auto;
      padding: 0;
    }
  }
}
.codedisplay-tip	{
  &.el-tooltip__popper {
    &.is-light {
      color: #FF0012;
      background: rgba(255, 255, 255, 0.9);
      border-color: #FFFFFF;
      padding: 5px;
      max-width: 300px;
      margin-bottom: 0;
      @media screen and(max-width: 767px) {
        max-width: 200px;
      }
    }

  }
}
</style>

<style scoped lang='scss'>
.new_codedisplay {
  position: relative;
  width: 100%;
  height: 120px;
  .new_codedisplay_main_0 {
    background: #ff9270;
  }
  .new_codedisplay_main_1 {
    background: #FF7070;
  }
  .new_codedisplay_main_2 {
    background: #7098FF;
  }
  .new_codedisplay_main {
    display: flex;
    flex-direction: column;
    //justify-content: center;
    justify-content: flex-end;
    width: calc(100% - 100px);
    height: 100%;
    margin: 0 auto;
    padding: 0 20px;
    & > p {
      line-height: normal;
      width: 100%;
      text-align: center;
      color: white;
      font-weight: bold;
      font-size: 22px;
      //margin-bottom: 20px;
    }
    & > div {
      padding: 20px 10px 30px;
      width: 100%;
      text-align: center;
      color: white;
      cursor: pointer;
      font-size: 14px;
      & > .text-overflow-1 {
        text-decoration: underline;
        margin-right: 5px;
      }
    }
  }
  & > img {
    position: absolute;
    top: 0;
    display: block;
    height: 100%;
  }
  .new_codedisplay_left {
    left: 0;
  }
  .new_codedisplay_right {
    right: 0;
  }
}
@media screen and(max-width: 768px) {
  .new_codedisplay {
    height: 100px;
    .new_codedisplay_main {
      padding: 0 10px;
      & > p {
        font-size: 18px;
        // margin-bottom: 15px;
        -webkit-tap-highlight-color: transparent !important;
        background: none !important;
        outline: none !important;
      }
      & > div {
        padding: 15px 10px 25px;
        font-size: 14px;
      }
    }
  }
}
.modal-dialog {
  box-shadow: unset;
}
.manner {
  position: relative;
  width: 100%;
  font-weight: bold;
  font-size: 16px;

  h3 {
    font-size: 13px;
    color: #ff8328;
    margin: 0;
  }
  h4 {
    font-size: 12px;
    color: #fff;
    margin-bottom: 10px;
  }
  .left {
    width: 62%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 10%;
    top: 0;
    left: 0;
    position: absolute;
    // top: 18%;
    // left: 10%;
    z-index: 2;
    //width: 200px;
    overflow: hidden;
    color: #fff;
    font-size: 18px;
    white-space: nowrap;
    text-overflow: ellipsis;
    p {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      color: #ed1412;
      line-height: 28px;
      -webkit-tap-highlight-color: transparent !important;
      background: none !important;
      outline: none !important;
    }
  }
  .right {
    width: 38%;
    top: 0;
    right: 0;
    height: 100%;
    padding-left: 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    //text-align: left;
    position: absolute;
    // top: 18%;
    // left: 70%;
    //width: 30%;
    z-index: 2;
    white-space: nowrap;
    h4 {
      width: 100%;
      margin-bottom: 0;
      margin-top: 10%;
    }
    p {
      position: absolute;
      cursor: pointer;
      height: 100%;
      color: #FF9844;
      padding: 22% 30% 8%;
      margin-left: -5%;
      //display: block;
      //width: 70%;
      font-size: 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    &:hover {
      &+svg {
        #mannerImage {
          fill: url('#paint2_linear_937_3344');
        }
      }
    }
  }
  svg {
    height: 100%;
  }
}
 #mannerImage {
   &:hover {
    fill: url('#paint2_linear_937_3344');
  }
}
.message {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 500px;
}
.tip {
  text-align: left;
  position: absolute;
  left: 30%;
  top: 18%;
  h2 {
    font-size: 20px !important;
    font-weight: 400;
  }
  p {
    font-size: 15px;
    text-shadow: unset;
  }
}
.default {
  max-width: 400px;
  margin: 0 auto;
  .left {
    text-align: left;
    p {
      font-size: 18px !important;
      margin: 0;
    }
  }
  .right {
    p {
      width: 100%;
    }
  }
}
.venue {
  .left {
    text-align: left;
    h3 {
      font-size: 13px;
      line-height: normal;
    }
    p {
      font-size: 18px !important;
      margin-bottom: 0;
    }
  }
  .right {
    h4 {
       margin-top: 5% !important;
    }
    p {
      width: 100%;
    }
  }
}
.showtime,
.vogue {
  max-width: 400px;
  text-align: center;

  .left {
    text-align: left;
    p {
      font-size: 18px !important;
      margin-bottom: 0;
    }
  }
}
.showtime {
  .right {
    p {
      width: 100%;
    }
  }
}
.vogue {
  .right {
    p {
      width: 100%;
    }
  }
}
.athena {
  .right {
    position: unset;
    h4,
    p {
      position: absolute;
      z-index: 1;
      left: 74%;
    }
    h4 {
      top: 20%;
    }
    p {
      top: 51%;
      max-width: 20%;
      padding: 1.1% 0;
      transform: unset !important;
      text-align: left;
      line-height: 1.2;
    }
  }
}

@media screen and(max-width:768px) {
  h4 {
    margin: 0 !important;
  }
  .tip {
    left: 30%;
    h2 {
      color: #fff;
      font-size: 14px !important;
    }
    p {
      font-size: 12px !important;
    }
  }
  .manner {
    .left {
      // width: 140px !important;
      max-width: 52%;
      > p {
        font-size: 14px !important;
      }
    }
  }
  .default {
    .left {
      h3 {
        font-size: 12px;
      }
      p {
        font-size: 14px !important;
        margin: 0;
      }
    }
    .right {
      font-size: 14px;
      h4 {
        margin-top: 10% !important;
        margin-bottom: 4px !important;
      }
    }
  }
  .venue {
    .left {
      h3 {
        font-size: 12px;
      }
      p {
        font-size: 14px !important;
      }
    }
    .right {
      h4 {
        margin-top: 5% !important;
        margin-bottom: 5px !important;
      }
    }
  }
  .showtime {
    .left {
      h3 {
        font-size: 12px;
      }
      p {
        font-size: 14px !important;
        margin: 0;
      }
    }
    .right {
      font-size: 12px;
      h4 {
        margin-top: 10% !important;
        margin-bottom: 8px !important;
      }
      p {
        margin-bottom: 0;
      }
    }
  }
  .vogue {
    .right {
      h4 {
        margin-top: 10% !important;
        margin-bottom: 5px !important;
      }
    }
  }
  .manner {
    .right {
      h4 {
        margin-bottom: 0 !important;
      }
    }
  }
}
</style>